import sessionstorage from 'sessionstorage';

const set = (key, value) => {
  if (!key || value === undefined) {
    return;
  }

  if (typeof value === 'object' && value !== null) {
    value = JSON.stringify(value);
  }

  sessionstorage.setItem(key, value);
};

const setMap = (key, map) => {
  const mapAsArray = Array.from(map);
  sessionstorage.setItem(key, JSON.stringify(mapAsArray));
};

const get = (key) => {
  if (!key) {
    return null;
  }

  const value = sessionstorage.getItem(key);

  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
};

const getMap = (key) => {
  const mapAsArray = JSON.parse(sessionstorage.getItem(key));
  return new Map(mapAsArray);
};

const remove = (key) => {
  if (!key) {
    return;
  }
  sessionstorage.removeItem(key);
};

const clearAll = () => {
  sessionstorage.clear();
};

const sessionStorageUtils = {
  set,
  setMap,
  get,
  getMap,
  remove,
  clearAll,
};

export default sessionStorageUtils;
